/* eslint-disable @typescript-eslint/no-explicit-any */
import { sendComponentViewedEvent } from './search-events-dispatcher'
import { ListingType } from '../../__generated__/fed-graphql-types'
import { TrackingContext } from '../../utils/tracking/tracking'
import type { TrackViewInteractionCallback } from '../../hooks/tracking/useTrackViewedInteraction.hook'

const TIME_BETWEEN_COMPONENT_VIEWS = 5000
const INITIAL_WAIT_FOR_EVENTS = 100

export class ComponentViewDispatcher {
    private static fullyVisibleAdverts = new Map<number, ScrollEvent>()
    private static previouslyRecordedPositions = new Set<number>()
    private static intervalRef: number

    public static isRunning = false

    public static componentIsFullyVisible(event: ScrollEvent, trackInteraction: TrackViewInteractionCallback): void {
        this.fullyVisibleAdverts.set(event.computeKey(), event)
        if (!this.isRunning) {
            this.startFiringComponentEvents(trackInteraction)
        }
    }

    public static reset(): void {
        if (this.intervalRef) {
            window.clearInterval(this.intervalRef)
        }
        this.fullyVisibleAdverts.clear()
        this.previouslyRecordedPositions.clear()
        this.isRunning = false
    }

    private static getHighestPositionEvent(): ScrollEvent {
        const maxPosition = Math.max(...this.fullyVisibleAdverts.keys())
        return this.fullyVisibleAdverts.get(maxPosition) as ScrollEvent
    }

    public static startFiringComponentEvents(trackInteraction: TrackViewInteractionCallback): void {
        if (this.getHighestPositionEvent() == undefined) {
            return
        }
        this.isRunning = true
        window.setTimeout(() => {
            this.sendEvent(trackInteraction)
            this.intervalRef = window.setInterval(() => {
                this.sendEvent(trackInteraction)
            }, TIME_BETWEEN_COMPONENT_VIEWS)
        }, INITIAL_WAIT_FOR_EVENTS)
    }

    private static sendEvent(trackInteraction: TrackViewInteractionCallback) {
        const highestPositionEvent = this.getHighestPositionEvent()

        if (highestPositionEvent && !this.previouslyRecordedPositions.has(highestPositionEvent.computeKey())) {
            sendComponentViewedEvent(highestPositionEvent, trackInteraction)
            this.previouslyRecordedPositions.add(highestPositionEvent.computeKey())
        }
    }
}

export class ScrollEvent {
    public listingType: ListingType
    public trackingContext: TrackingContext | null
    public constructor(listingType: ListingType, trackingContext: TrackingContext | null) {
        this.listingType = listingType
        this.trackingContext = trackingContext
    }

    public computeKey(): number {
        return parseFloat(
            `${this.trackingContext?.card.pageNumber}.${this.trackingContext?.card.position
                .toString(10)
                .padStart(2, '0')}`
        )
    }
}
